const tools = {
  // 添加cookie参数
  /**
     *
     * @param {名称} name
     * @param {值} value
     * @param {时间} time
     */
  addCookie: function (name, value) {
    document.cookie = name + '=' + value + '; path=/'
  },
  // 查询cookie参数
  /**
     *
     * @param {名称} name
     */
  getCookie: function (name) {
    if (document.cookie.indexOf(name) > -1) {
      const arr = document.cookie.split(';')
      let str = ''
      arr.forEach(item => {
        if (item.indexOf(name) > -1) {
          str = item.split(`${name}=`)[1]
        }
      })
      return str
    } else {
      return ''
    }
  },
  // 删除cookie参数
  /**
     *
     * @param {名称} name
     */
  removeCookie: function (name) {
    document.cookie = name + '=' + '' + '; path=/'
  }
}
export {
  tools
}
